export default __webpack_public_path__ + "static/media/icon_placeholder_password.8be7e958.svg";